export const PerformanceCategory = {
    Solo: "Solo",
    Ensemble: "Ensemble"
}

export const ageCategories = {
    Poco: "Poco (4-5 years old)",
    Petite: "Petite (6-7 years old)",
    Primary: "Primary (8-11 years old)",
    Young: "Young (12-15 years old)",
    Junior: "Junior (16-19 years old)",
    Youth: "Youth (20-23 years old)",
    OpenAge: "Open Age (24+ years old)",
    JuniorEtude: "Junior Etude (4+ years old)",
    ConcertEtude: "Concert Etude (4+ years old)",
    FreeChoice: "Free Choice (4+ years old)",
    YoungArtists: "Young Artists (4+ years old)",
}

export const ensembleAgeCategories = {
    older_than_four: "4+* years old (Combination Age)",
}

export const stringAgeCategoriesSolo = {
    Poco: "Poco (4-5 years old)",
    Petite: "Petite (6-7 years old)",
    Primary: "Primary (8-11 years old)",
    Young: "Young (12-15 years old)",
    Junior: "Junior (16-19 years old)",
    Youth: "Youth (20-23 years old)",
    OpenAgeStrings: "Open Age (4+ years old)",
    FreeChoice: "Free Choice (4+ years old)",
    ProfessionalsStrings: "Professionals (19-30 years old)",
}

export const stringAgeCategoriesEnsemble = {
    four_nineteen: "4-19 years old",
    nineteen_plus: "19-30 years old",
    mixed: "Mixed",
}

export const vocalAgeCategoriesSolo = {
    PetiteVocal: "Petite (4-6 years old)",
    PrimaryVocal: "Primary (7-9 years old)",
    YoungVocal: "Young (10-12 years old)",
    JuniorVocal: "Junior (13-15 years old)",
    YouthVocal: "Youth (16-19 years old)",
    OpenAgeVocal: "Open Age (9+ years old)",
    ProfessionalVocal: "Professionals (19+ years old)",
    FreeChoiceVocal: "Free Choice (4+ years old)",
}

export const vocalAgeCategoriesEnsemble = {
    four_nineteen: "4-19 years old",
    nineteen_plus: "19-30 years old",
    mixed: "Mixed",
}

export const woodwinAgeCategoriesSolo = {
    PetitewoodWind: "Petite (4-6 years old)",
    PrimarywoodWind: "Primary (7-9 years old)",
    YoungwoodWind: "Young (10-12 years old)",
    JuniorwoodWind: "Junior (13-15 years old)",
    YouthwoodWind: "Youth (16-19 years old)",
    Professionals: "Professionals (19+ years old)",
    OpenAgewoodWind: "Open Age (4+ years old)",
    FreeChoicewoodWind: "Free Choice (4+ years old)",
}

export const woodwinAgeCategoriesEnsemble = {
    four_nineteen: "4-19 years old",
    nineteen_plus: "19+ years old",
    mixed: "Mixed (Combination age)",
}

export const percussionAgeCategoriesSolo = {
    PetitePercussion: "Petite (6-7 years old)",
    PrimaryPercussion: "Primary (8-11 years old)",
    YoungPercussion: "Young (12-14 years old)",
    JuniorPercussion: "Junior (15-18 years old)",
    YouthPercussion: "Youth (19-22 years old)",
    OpenAgePercussion: "Open Age (23+ years old)",
    FreeChoicePercussion: "Free Choice (4+ years old)",
}

export const PercussionAgeCategoriesEnsemble = {
    Combination: "Combination",
}

export const guitarAgeCategoriesSolo = {
    PetiteGuitar: "Petite (4-6 years old)",
    PrimaryGuitar: "Primary (7-9 years old)",
    YoungGuitar: "Young (10-12 years old)",
    JuniorGuitar: "Junior (13-15 years old)",
    YouthGuitar: "Youth (16-19 years old)",
    OpenAgeGuitar: "Open Age (4+ years old)",
    FreeChoiceGuitar: "Free Choice (4+ years old)",
}

export const guitarAgeCategoriesEnsemble = {
    four_nineteen: "4-19 years old",
    nineteen_plus: "19+ years old",
    mixed: "Mixed",
}

export const brassAgeCategoriesSolo = {
    PetiteBrass: "Petite (4-6 years old)",
    PrimaryBrass: "Primary (7-9 years old)",
    YoungBrass: "Young (10-12 years old)",
    JuniorBrass: "Junior (13-15 years old)",
    YouthBrass: "Youth (16-19 years old)",
    OpenAgeBrass: "Open Age (4+ years old)",
    FreeChoiceBrass: "Free Choice (4+ years old)",
}

export const brassAgeCategoriesEnsemble = {
    four_nineteen: "4-19 years old",
    nineteen_plus: "19+ years old",
    mixed: "Mixed",
}

export const harpAgeCategoriesSolo = {
    PetiteHarp: "Petite (4-6 years old)",
    PrimaryHarp: "Primary (7-9 years old)",
    YoungHarp: "Young (10-12 years old)",
    JuniorHarp: "Junior (13-15 years old)",
    YouthHarp: "Youth (16-19 years old)",
    OpenAgeHarp: "Open Age (4+ years old)",
    FreeChoiceHarp: "Free Choice (4+ years old)",
}

export const harpAgeCategoriesEnsemble = {
    four_nineteen: "4-19 years old",
    nineteen_plus: "19+ years old",
    mixed: "Mixed",
}


export const competitionList = {
    Piano: "Piano",
    Woodwinds: "Woodwinds",
    Percussions: "Percussions",
    Strings: "Strings",
    Brass: "Brass",
    Guitar: "Guitar",
    VocalChoir: "VocalChoir",
    Harp: "Harp",
}

export const PianoInstrumentList = {
    Piano_Solo: "Piano Solo (One piano, two hands)",
    Piano_Fourhands_one: "Piano Fourhands (One piano, four hands)",
    Piano_Fourhands_two: "Piano Fourhands (Two pianos, four hands)",
    Chamber_Music_one: "Chamber Music (One piano, six-eight hands)",
    Chamber_Music_two: "Chamber Music (Two pianos, six-eight hands)",
    Chamber_Music_any: "Chamber Music (Any instrument(s) with piano(s))",
}

export const PianoInstrumentListSolo = {
    Piano_Solo: "Piano Solo (One piano, two hands)",
}

export const PianoInstrumentListEnsembleNew = {
    Professionals_any_genre: "Professionals (Any genre song)",
    Non_Professionals_any_genre: "Non_Professionals (Any genre song)",
    Professionals_Own_Arrangement: "Professionals (Own Arrangement)",
    Non_Professionals_Own_Arrangement: "Non_Professionals (Own Arrangement)"
}

export const StringsInstrumentListSolo = {
    Violin: "Violin",
    Viola: "Viola",
    Cello: "Cello",
    DoubleBass: "Double Bass",
    AnyTraditionalStrings: "Any Traditional Strings",
}

export const StringsInstrumentListEnsemble = {
    twoToFive: "2-5 Performers (combination of any instruments)",
    sixToNine: "6-9 Performers (combination of any instruments)",
    tenToFifteen: "10-15 Performers (combination of any instruments)",
}

export const VocalInstrumentListSolo = {
    SoloVocal: "Solo With Acoustic Instrument (Classical)",
    SoloAcousticVocal: "Solo Without Acoustic Instrument (Free Genre)"
}

export const VocalInstrumentListEnsembleElaborated = {
    twoToFive: "2-5 performer",
    sixToNine: "6-9 performer",
    tenToFifteen: "10-15 performer",
    sixteenToTwenty: "16-20 performer",
    twentyOneToThirty: "20-30 performer",
}

export const PercussionInstrumentListSolo = {
    Marimba: "Marimba",
    Vibraphone: "Vibraphone",
    Multi_percussion: "Multi Percussion",
    Any_Traditional_Percussion: "Any Traditional Percussion",
}

export const PercussionInstrumentListEnsemble = {
    Duo: "Duo",
    Trio: "Trio",
    Quartet: "Quartet"
}


export const GuitarInstrumentListSolo = {
    Classic: "Classical Nylon Guitar (Classical)",
    FreeGenre: "Any Acoustic Guitar Strings and Nylon (Free Genre)*",
    Any_Traditional_Guitar: "Any Traditional Guitar",
}

export const GuitarInstrumentListEnsemble = {
    twoToFive: "2-5 Performers (combination of any instruments)",
    sixToNine: "6-9 Performers (combination of any instruments)",
    tenToFifteen: "10-15 Performers (combination of any instruments)",
}

export const HarpInstrumentListSolo = {
    pedal: "Pedal Harp",
    lever: "Lever Harp",
    Any_Traditional_Harp: "Any Traditional Harp",
}

export const HarpInstrumentListEnsemble = {
    twoToFive: "2-5 Performers (combination of any instruments)",
    sixToNine: "6-9 Performers (combination of any instruments)",
    tenToFifteen: "10-15 Performers (combination of any instruments)",
}

export const BrassInstrumentListSolo = {
    trumpet: "Trumpet",
    trombone: "Trombone",
    french_horn: "French Horn",
    tuba: "Tuba",
    any_traditional: "Any Traditional Brass",
}

export const BrassInstrumentListEnsemble = {
    twoToFive: "2-5 Performers (combination of any instruments)",
    sixToNine: "6-9 Performers (combination of any instruments)",
    tenToFifteen: "10-15 Performers (combination of any instruments)",
}

export const WoodwindInstrumentListSolo = {
    Piccolo: "Piccolo",
    Flute: "Flute",
    Oboe: "Oboe",
    Clarinet: "Clarinet",
    Saxophone: "Saxophone",
    Bassoon: "Bassoon",
    any_traditional_woodwind: "Any Traditional Woodwind",
}

export const WoodwindInstrumentListEnsemble = {
    woodwind_two_five_performer: "2-5 Performers (combination of any instruments)",
    woodwind_six_nine_performer: "6-9 Performers (combination of any instruments)",
    woodwind_ten_fifteen_performer: "10-15 Performers (combination of any instruments)"
}